import styled from 'styled-components';
import { sizes } from 'style';
import { NextRow, Title, InfoText } from '../../styled';

export const InputWrapper = styled.div`
  margin-top: 8px;

  @media ${sizes.largeDesktop} {
    width: 50%;
  }
`;

export const BeneficiaryText = styled(InfoText)`
  @media ${sizes.largeDesktop} {
    width: 50%;
  }
`;

export const StyledNextRow = styled(NextRow)`
  margin-top: 24px;
`;

export const StyledTitle = styled(Title)`
  margin-bottom: 0;
`;
